import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';

import { AppUtils } from '../../shared/helpers/app.utils';
import { UserProfileStateService } from '../states/user-profile.state.service';

@Injectable({
    providedIn: 'root'
})
export class SponsorGuard implements CanActivate, CanLoad {

    constructor(
        private readonly router: Router,
        private readonly appUtils: AppUtils,
        private readonly userProfileStateService: UserProfileStateService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        return this.checkSponsorAccess(state.url);
    }

    canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree {
        const url = `/${segments.map(segment => segment.path).filter(Boolean).join('/')}`;
        return this.checkSponsorAccess(url);
    }

    private checkSponsorAccess(url: string): boolean | UrlTree {
        if (!this.appUtils.isUserAuthenticated()) {
            return this.router.parseUrl(`/auth/sign-in?returnUrl=${encodeURIComponent(url)}`);
        }

        if (!this.userProfileStateService.isSponsor) {
            return this.router.parseUrl('/home');
        }

        return true;
    }
}
